import React from 'react';
import { type SxProps, type Theme, type TooltipProps } from '@mui/material';
import { copiedIcon, copyIcon } from '@europrocurement/l2d-icons';
import { useCopyToClipboard } from '@europrocurement/l2d-hooks';
import { FlexyIconButton } from '../FlexyIconButton/FlexyIconButton';

export type CopyIconButtonProps = {
    copyValue: string;
    size?: number;
    iconSize?: string;
    tooltipPlacement?: TooltipProps['placement'];
    disabled?: boolean;
    className?: string;
    sx?: SxProps<Theme>;
};

export const CopyIconButton: React.FunctionComponent<CopyIconButtonProps> = function ({
    copyValue,
    size = 24,
    iconSize = '11px',
    tooltipPlacement = 'bottom',
    disabled = false,
    className,
    sx,
}) {
    const { copied, copying, copy } = useCopyToClipboard();

    const handleCopy = async (e: React.MouseEvent) => {
        e.stopPropagation();
        await copy(copyValue);
    };

    return (
        <FlexyIconButton
            icon={copied ? copiedIcon : copyIcon}
            tooltip={copied ? 'Copié !' : 'Copier'}
            tooltipPlacement={tooltipPlacement}
            onClick={handleCopy}
            normalHoverColor={undefined}
            buttonOverwriteProps={{
                className,
                'data-copied': copied ? 'true' : undefined,
                sx: {
                    width: size,
                    height: size,
                    padding: '4px',
                    borderRadius: '4px',
                    transition: 'all 0.2s ease-in-out',
                    ...(copying && { pointerEvents: 'none' }),
                    ...sx,
                },
            }}
            iconOverwriteProps={{
                sx: {
                    fontSize: iconSize,
                    color: copied ? 'success.main' : undefined,
                    transition: 'color 0.2s ease',
                },
            }}
            disabled={disabled}
        />
    );
};
